import { Link, Typography } from '@mui/material';

import Button from '@/components/Buttons/Button';
import GoLogo from '@/components/GoLogo';
import { SUPPORT_EMAIL } from '@/constants/constants';
import { spacing } from '@/constants/ui';
import { BaseLayout } from '@/layouts/BaseLayout';
import { CenteredLayout } from '@/layouts/CenteredLayout';

export const FullPageMessage = ({
  title,
  subtitle,
  buttonLabel,
  onButtonClick
}: {
  title: string;
  subtitle: string;
  buttonLabel: string;
  onButtonClick: () => void;
}) => (
  <BaseLayout>
    <CenteredLayout>
      <GoLogo size={74} />
      <Typography
        sx={{ textAlign: 'center', mt: spacing[4] }}
        variant='h1'
      >
        {title}
      </Typography>
      <Typography
        sx={{ my: spacing[2], maxWidth: 500, textAlign: 'center' }}
        variant='subtitle1'
      >
        {subtitle}
      </Typography>
      <Button
        sx={{
          width: 250,
          mb: spacing[3]
        }}
        variant='contained'
        onClick={onButtonClick}
      >
        {buttonLabel}
      </Button>
      <Typography sx={{ textAlign: 'center' }}>
        Any issues? Drop us a line at{' '}
        <Link
          color='text.primary'
          href={`mailto:${SUPPORT_EMAIL}`}
          sx={{ whiteSpace: 'nowrap' }}
          target='_top'
        >
          {SUPPORT_EMAIL}
        </Link>
      </Typography>
    </CenteredLayout>
  </BaseLayout>
);
